/**
 * A global namespace for aria-valuemax.
 */
const ariaValueMax = "aria-valuemax";
export default ariaValueMax;
